var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-content-wrapper pt-0" }, [
    _vm.step === "companies-info"
      ? _c("div", [_c("companies-info", { attrs: { type: "create" } })], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.step === "companies-created"
      ? _c(
          "div",
          [
            _c("companies-created", {
              attrs: { type: "create" },
              on: { saved: _vm.saved }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step === "companies-map"
      ? _c(
          "div",
          [
            _c("companies-map", {
              attrs: { type: "create" },
              on: { saved: _vm.saved }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step === "companies-settings"
      ? _c(
          "div",
          [
            _c("companies-settings", {
              attrs: { type: "create" },
              on: { saved: _vm.saved }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step === "companies-availability"
      ? _c(
          "div",
          [
            _c("companies-availability", {
              attrs: { type: "create" },
              on: { saved: _vm.saved }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.step === "companies-pricing"
      ? _c(
          "div",
          [
            _c("companies-pricing", {
              attrs: { type: "create" },
              on: { saved: _vm.saved }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51c925fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c925fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesCreate.vue
// module id = null
// module chunks = 